// Types
import { BoxProps } from '../types/container/box';

export const validate = ({
  type,
  addKey,
  addReel,
  addValue,
  addBlock,
  addRepel,
  scrollbar,
  addCluster,
  addSwitcher,
  addKeyValue,
}: BoxProps) => {
  if (addKeyValue && (addValue !== undefined || addKey !== undefined)) {
    throw new Error(
      "Configuration Item 'addKeyValue' should not be configured alongside 'addValue' and 'addKey' as the latter two are meant to be child elements.",
    );
  }

  if (addValue !== undefined && addKey !== undefined) {
    throw new Error(
      "Configuration Items 'addValue' and 'addKey' should not be used on the same element as they are designed to be siblings with 'addKeyValue' as the parent.",
    );
  }

  if (addSwitcher && (addRepel || addCluster || addBlock)) {
    throw new Error(
      "Configuration Item 'addSwitcher' should not be used in conjunction with 'addBlock', 'addRepel' or 'addCluster'",
    );
  }

  if (scrollbar !== undefined && !addReel) {
    throw new Error(
      "Configuration Item 'scrollbar' should only be used when 'addReel' is 'true'",
    );
  }

  if (type === 'vertical' && !addRepel) {
    throw new Error(
      "Configuration Item 'vertical' should only be used when 'addRepel' is 'true'",
    );
  }
};
